<template>
  <div id="app">
<!--    <nav>-->
<!--      <router-link to="/">Home</router-link> |-->
<!--      <router-link to="/about">About</router-link>-->
<!--    </nav>-->
    <router-view/>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: '%s | Robinhood Creator',
  },
};
</script>

<style lang="scss">
@import "./assets/sass/app";
@import "./assets/sass/artwork";
@import "./assets/sass/hotel";
</style>
